import { resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_overlay = _resolveComponent("app-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent($setup.AppliedLayout), {
      id: "app",
      key: "root-app",
      class: _normalizeClass($setup.appClasses)
    }, null, 8, ["class"])),
    _createVNode(_component_app_overlay)
  ], 64))
}